import styled from '@emotion/styled'
import { ScrollOverMediaDocumentDataStickiesItem } from '../../../../types.generated'
import { PrismicRichText } from '@prismicio/react'
import { asText } from '@prismicio/client'
import { useIsPortrait } from '../../../util/breakpoints'

export interface StickiesProps {
  data: ScrollOverMediaDocumentDataStickiesItem[]
  zIndex: number
}

export const Stickies = (props: StickiesProps) => {
  const isPortrait = useIsPortrait()

  return <StickyContainer zIndex={props.zIndex}>
    {props.data?.filter((sticky) => sticky.text && sticky.text.length > 0)
      .map((sticky, index) => {
        let stickyCss = ''
        if (isPortrait) {
          stickyCss = asText(sticky.sticky_portrait_css)
        } else {
          stickyCss = asText(sticky.sticky_landscape_css)
        }

        return (
          <Sticky containerCss={stickyCss} key={index}>
            <PrismicRichText field={sticky.text} />
          </Sticky>
        )
      })}
  </StickyContainer>
}

const StickyContainer = styled.div<{ zIndex: number }>`
    position: sticky;
    width: 100%;
    height: 100vh;
    pointer-events: none;

    z-index: ${(props) => props.zIndex};
`

const Sticky = styled.div<{ containerCss: string }>`
    position: absolute;
    pointer-events: auto;

    display: flex;
    flex-direction: column;

    ${({ containerCss }) => containerCss}
`
